module.exports = "<div class=\"comp-toast\"\n     id=\"compToast\"\n     :class=\"isShow === true ? 'comp-toast--' + type + ' slide-fade-enter-active' : ''\" ref=\"module\">\n    <div class=\"toast-wrapper\">\n        <div class=\"close\" @click=\"hide()\" v-if=\"type === 'error'\">\n            <i class=\"icon icon-close\"></i>\n        </div>\n        <span class=\"text\">{{content}}</span>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/component/Toast/Toast.html
// module id = 11
// module chunks = 0 1